import { render, staticRenderFns } from "./CriarEvento.vue?vue&type=template&id=0aabc560&scoped=true&lang=pug&"
import script from "./CriarEvento.vue?vue&type=script&lang=js&"
export * from "./CriarEvento.vue?vue&type=script&lang=js&"
import style0 from "./CriarEvento.vue?vue&type=style&index=0&id=0aabc560&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabc560",
  null
  
)

export default component.exports